import { useCallback, useEffect, useState } from 'react';

import useRecommendationsApi from '../../api/recommendations';

export default function useRecommendations({ start, end, lat, lng }) {
  const { fetchRecommendations, trackEvents } = useRecommendationsApi();

  const [state, setState] = useState({ items: [], source: null, status: 'loading', error: null });
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setState((s) => ({ ...s, status: 'loading', error: null }));

    fetchRecommendations(
      {
        start: start?.toISOString(),
        end: end?.toISOString(),
        lat,
        lng,
        refresh: nonce > 0 ? 1 : undefined,
      },
      controller.signal
    )
      .then((data) => {
        setState({ items: data.items, source: data.source, status: 'ready', error: null });
        trackEvents(
          data.items.map((a, i) => ({
            type: 'impression',
            vehiculeAnnonceId: a.vehiculeAnnonceId,
            rank: i + 1,
            source: data.source,
          }))
        );
      })
      .catch((err) => {
        if (controller.signal.aborted) return;
        setState({ items: [], source: null, status: 'error', error: err });
      });

    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [start?.getTime(), end?.getTime(), lat, lng, nonce, fetchRecommendations, trackEvents]);

  const reload = useCallback(() => setNonce((n) => n + 1), []);
  return { ...state, reload };
}
